export default function animateValue({
	                                     start = 0, end, duration = 2000, animatedValueChanged = () => {
	}
                                     }) {
	// assumes integer values for start and end

	if(end === undefined){
		throw new Error('"end" is required');
	}
	const range = end - start;
	// no timer shorter than 50ms (not really visible any way)
	const minTimer = 50;
	// calc step time to show all interediate values

	let stepTime = Math.abs(Math.floor(duration / range));

	// never go below minTimer
	stepTime = Math.max(stepTime, minTimer);

	// get current time and calculate desired end time
	const startTime = new Date().getTime();
	const endTime = startTime + duration;
	let timer;

	function run() {
		var now = new Date().getTime();
		var remaining = Math.max((endTime - now) / duration, 0);
		var value = Math.round(end - (remaining * range));
		animatedValueChanged(value);
		if(value === end) {
			clearInterval(timer);
		}
	}

	timer = setInterval(run, stepTime);
	run();

	return {
		stop: () => {
			clearInterval(timer);
		}
	};
}